// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"7cd94d00","239":"d21a2d30","455":"67083904","762":"66645716","785":"9c0202db","917":"68b810ba","977":"594ef3c7"}[chunkId] + ".chunk.js";
};